import { headersWithBasicAuth } from '@tuic/lib/request/headers';
import { logger } from '@tuic/logger';

import {
  ENDPOINT_CMW_API,
  ENDPOINT_CMW_BASIC_AUTH_PASSWORD,
  ENDPOINT_CMW_BASIC_AUTH_USER,
} from '../../utils';

export type AppStoreRatings = {
  ios?: number;
  android?: number;
};

/**
 * Returns the app store ratings form the CMW.
 * The underlying fetch call is cached for 900 seconds.
 */
export const getAppStoreRatings = async (): Promise<AppStoreRatings> => {
  try {
    const response = await fetch(`${ENDPOINT_CMW_API}/export/app-rating`, {
      headers: headersWithBasicAuth([
        ENDPOINT_CMW_BASIC_AUTH_USER,
        ENDPOINT_CMW_BASIC_AUTH_PASSWORD,
      ]),
      next: {
        revalidate: 900,
      },
    });

    const data = await response.json();

    return {
      ios: data.I_OS ? parseInt(data.I_OS, 10) : undefined,
      android: data.ANDROID ? parseInt(data.ANDROID, 10) : undefined,
    };
  } catch (e) {
    logger.error(e);
  }

  return {};
};
